import { defineCustomElement } from '@tyler-components-web/core';
import { FooterComponent } from './footer';
export * from './footer-constants';
export * from './footer';
export function defineFooterComponent() {
    defineCustomElement(FooterComponent);
}
